import { useNavigationContext } from '../context/NavigationContext';

export const useActiveRoute = (to: string | undefined) => {
  const { isRouteActive } = useNavigationContext();

  const isActive = isRouteActive(to);

  return {
    isActive
  };
};
